import { type FC } from 'react';
import { Tooltip } from 'antd';
import { GLOSSARY, type GlossaryEntry } from '@/lib/glossary';

interface BilingualLabelProps {
  glossaryKey: string;
  size?: 'sm' | 'md' | 'lg';
  showDefinition?: boolean;
  className?: string;
}

const SIZE_CLASSES: Record<string, { main: string; sub: string }> = {
  sm: { main: 'text-xs font-semibold', sub: 'text-[10px]' },
  md: { main: 'text-sm font-semibold', sub: 'text-xs' },
  lg: { main: 'text-xl font-bold', sub: 'text-sm' },
};

export const BilingualLabel: FC<BilingualLabelProps> = ({
  glossaryKey,
  size = 'md',
  showDefinition = true,
  className = '',
}) => {
  const term: GlossaryEntry | undefined = GLOSSARY[glossaryKey];
  if (!term) return <span className={className}>{glossaryKey}</span>;

  const classes = SIZE_CLASSES[size];

  const content = (
    <div className={className}>
      <span className={`${classes.main} text-inherit`}>{term.en}</span>
      <span
        className={`block italic text-slate-500 dark:text-slate-400 ${classes.sub}`}
      >
        {term.fr}
      </span>
    </div>
  );

  if (showDefinition) {
    return (
      <Tooltip
        title={term.definition}
        overlayClassName="max-w-xs"
        placement="bottom"
      >
        {content}
      </Tooltip>
    );
  }

  return content;
};

export default BilingualLabel;
